import { useAgentNameMap } from '@/hooks/useAgentNameMap';

/**
 * 根据 agentId 展示对应 Agent 的名称（对齐 UserName 组件的用法）。
 * - 已知映射：展示 name
 * - 未知 / 未加载 / agentId 缺失：展示 '-'，不回退展示原始 ID
 */
export function AgentName({ agentId }: { agentId?: string | null }) {
  const nameMap = useAgentNameMap();
  if (!agentId) return <>-</>;
  return <>{nameMap[agentId] || '-'}</>;
}

export default AgentName;
